import userCan, { PermissionModel, UserActions } from "@granular/authz";
import * as hooks from "./hooks/index.public";

// This is the PUBLIC next object. Only place items in here you want to be available at the root.
// Anything in here MUST be documented on https://fabric.granular.ag AND mocked in testing/mocks
export const next = {
  hooks,
  userCan,
};

export type { PermissionModel, UserActions };
